import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { IGroupList } from '../interface/groupList';
import { GetGroupAdapter } from '../adapter/getGroupAdapter';

/**
 * グループを取得するUseCase
 */
export class GetGroupUseCase {
  /**
   * グループを取得する モック関数
   * @param repository - リポジトリ
   */
  public ExecuteMock = async (repository: IGroupRepository): Promise<INetworkResult<IGroupList, Error>> => {
    try {
      const result = await repository.getGroup();

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const data = GetGroupAdapter.adaptForResponse(result.status.data);

      return {
        status: {
          type: 'success',
          data: data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  };
}
